import { render, staticRenderFns } from "./GroupButtons.vue?vue&type=template&id=14faaad5&"
import script from "./GroupButtons.vue?vue&type=script&lang=ts&"
export * from "./GroupButtons.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports